export default __webpack_public_path__ + "static/media/bphoto1.6b643d04.jpeg";